import './nav.css'
import React, { useState } from 'react'
// components
import {
  AiOutlineHome,
  AiOutlineUser
} from 'react-icons/ai'
import {
  BiBook,
  BiMessageSquareDetail
} from 'react-icons/bi'
import {RiProjectorLine} from 'react-icons/ri'

const Nav = () => {
  const [activeNav,setActiveNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={() => {setActiveNav('#')}} className={activeNav === '#' ? 'active' : null}><AiOutlineHome /></a>
      <a href="#about" onClick={() => {setActiveNav('#about')}} className={activeNav === '#about' ? 'active' : null}><AiOutlineUser /></a>
      <a href="#experience" onClick={() => {setActiveNav('#experience')}} className={activeNav === '#experience' ? 'active' : null}><BiBook /></a>
      <a href="#portfolio" onClick={() => {setActiveNav('#portfolio')}} className={activeNav === '#portfolio' ? 'active' : null}><RiProjectorLine /></a>
      <a href="#contact" onClick={() => {setActiveNav('#contact')}} className={activeNav === '#contact' ? 'active' : null}><BiMessageSquareDetail /></a>
    </nav>
  )
}

export default Nav